module.exports = __webpack_public_path__ + "img/Body_MetalRoughness.5235f11.jpg";